import * as React from 'react';
import { SVGProps } from 'react';

const IconFileCodeSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <path d="M2.5 3.5A2.5 2.5 0 0 1 5 1h.5v1H5a1.5 1.5 0 0 0-1.5 1.5v1.672a2.5 2.5 0 0 1-.732 1.767l-.56.561.56.56A2.5 2.5 0 0 1 3.5 9.829V12.5A1.5 1.5 0 0 0 5 14h.5v1H5a2.5 2.5 0 0 1-2.5-2.5V9.828a1.5 1.5 0 0 0-.44-1.06L.794 7.5l1.268-1.268a1.5 1.5 0 0 0 .44-1.06V3.5ZM11 2h-.5V1h.5a2.5 2.5 0 0 1 2.5 2.5v1.672c0 .397.158.779.44 1.06L15.206 7.5 13.94 8.768a1.5 1.5 0 0 0-.439 1.06V12.5A2.5 2.5 0 0 1 11 15h-.5v-1h.5a1.5 1.5 0 0 0 1.5-1.5V9.828a2.5 2.5 0 0 1 .732-1.767l.561-.561-.56-.56a2.5 2.5 0 0 1-.733-1.768V3.5A1.5 1.5 0 0 0 11 2Z" />
    <path d="m10.924 4.265-5 8-.848-.53 5-8 .848.53Z" />
  </svg>
);
export default IconFileCodeSizeS;
